document.addEventListener('DOMContentLoaded', function() {
  var deptBtn    = document.getElementById('departments-btn');
  var panel      = document.getElementById('dept-panel');
  var backBtn    = document.getElementById('back-btn');
  var menuList   = document.getElementById('menu-list');
  var header     = document.getElementById('menu-header');
  var sidePanel  = document.getElementById('fourth-level-panel');

  var stack       = [];
  var titleStack  = [];
  var currentMenu = menuData;

  menuList.style.transition = 'transform 0.25s ease-in-out, opacity 0.15s ease-in-out';
  menuList.style.opacity    = '0';
  menuList.style.transform  = 'translateX(0)';

  function renderMenu(menu, direction) {
    menuList.style.transform = direction === 'in'   ? 'translateX(100%)'
                          : direction === 'out'  ? 'translateX(-100%)'
                          : 'translateX(0)';
    menuList.style.opacity = '0';

    setTimeout(function() {
      header.textContent   = titleStack.length ? titleStack[titleStack.length - 1] : '';
      header.style.display = titleStack.length ? 'block' : 'none';

      menuList.innerHTML = menu.map(function(item, idx) {
        return '<li data-index="'+idx+'">'
             +   '<a href="'+(item.children ? '#' : (item.href || `/collections/${item.handle}`))+'">'
             +     item.title + (item.children ? ' ▸' : '')
             +   '</a>'
             + '</li>';
      }).join('');

      backBtn.style.display = stack.length ? 'block' : 'none';
      menuList.style.transform = 'translateX(0)';
      menuList.style.opacity   = '1';
    }, 100);
  }

  function renderFourthLevelMenu(items, parentTitle = '') {
    const panel = document.getElementById('fourth-level-panel');
    if (!panel) return;

    const heading = `<div style="
      font-weight: bold;
      color: #003366;
      font-size: 16px;
      margin-bottom: 10px;
      text-align: left;
    ">${parentTitle}</div>`;

    const content = `
      <div class="fourth-grid">
        ${items.map(item => {
          const imgSrc = item.image || 'https://via.placeholder.com/300';
          const href   = item.url || `/collections/${item.handle}`;

          return `
            <div class="ltn__category-item horizontal-card">
              <div class="ltn__category-item-img">
                <a href="${href}">
                  <img src="${imgSrc}" alt="${item.title}" loading="lazy" class="image-position-size"/>
                </a>
              </div>
              <div class="ltn__category-item-name">
                <h5 style="margin:0;">
                  <a href="${href}" style="color: #000; text-decoration: none;">
                    ${item.title}
                  </a>
                </h5>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;

    panel.innerHTML = heading + content;
    panel.classList.add('active');
  }

  deptBtn.addEventListener('click', function(e) {
    e.preventDefault(); e.stopPropagation();
    document.body.classList.add('menu-open');
    panel.classList.add('active');
    stack = [];
    titleStack = [];
    header.style.display = 'none';
    currentMenu = menuData;
    renderMenu(currentMenu, 'in');
    sidePanel.classList.remove('active');
  });

  let hoverTimer = null;

  menuList.addEventListener('mouseover', function(e) {
    if (!window.fourthMenuReady) return;
    const li = e.target.closest('li');
    if (!li) return;

    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      const idx = +li.getAttribute('data-index');
      const item = currentMenu[idx];
      const depth = stack.length;

      if (depth === 1) {
        const matchKey = Object.keys(window.fourthLevelMenu || {}).find(k =>
          k.trim().toLowerCase() === item.title.trim().toLowerCase()
        );

        if (matchKey) {
          const fourthItems = window.fourthLevelMenu[matchKey];
          renderFourthLevelMenu(fourthItems, item.title);
        } else {
          sidePanel.classList.remove('active');
        }
      }
    }, 100);
  });

  menuList.addEventListener('mouseleave', function () {
    clearTimeout(hoverTimer);
    setTimeout(() => {
      if (!sidePanel.matches(':hover') && !menuList.matches(':hover')) {
        sidePanel.classList.remove('active');
      }
    }, 100);
  });

  menuList.addEventListener('click', function(e) {
    if (!window.fourthMenuReady) {
      console.warn("⚠️ fourthLevelMenu not ready yet.");
      return;
    }

    const li = e.target.closest('li');
    if (!li) return;

    e.preventDefault(); e.stopPropagation();

    const idx = +li.getAttribute('data-index');
    const item = currentMenu[idx];

    if (!item) return;

    const isSecondLevel = stack.length === 0;
    const isThirdLevel  = stack.length === 1;

    // → If clicking a 3rd-level without children, follow link
    if (isThirdLevel && !item.children) {
  panel.classList.remove('active');
  sidePanel.classList.remove('active');
  document.body.classList.remove('menu-open');
  
  const href = item.href || `/collections/${item.handle}`;
  window.location.href = href;
  return;
}


    // → Proceed with drilldown
    stack.push(currentMenu);
    titleStack.push(item.title);
    currentMenu = item.children || [];

    if (isSecondLevel) {
      // Collect all 4th-level items from children
      const allFourth = [];
      currentMenu.forEach(lvl3 => {
        const key = Object.keys(window.fourthLevelMenu || {}).find(k =>
          k.trim().toLowerCase() === lvl3.title.trim().toLowerCase()
        );
        if (key && Array.isArray(window.fourthLevelMenu[key])) {
          allFourth.push(...window.fourthLevelMenu[key]);
        }
      });

      if (allFourth.length) {
        renderFourthLevelMenu(allFourth, item.title);
      } else {
        sidePanel.classList.remove('active');
        sidePanel.innerHTML = '';
      }
    }

    renderMenu(currentMenu, 'in');
  });

  backBtn.addEventListener('click', function(e) {
    e.preventDefault(); e.stopPropagation();
    if (stack.length) {
      currentMenu = stack.pop();
      titleStack.pop();
      renderMenu(currentMenu, 'out');
      panel.classList.add('active');
      document.body.classList.add('menu-open');
    }
    sidePanel.classList.remove('active');
    sidePanel.innerHTML = '';
  });

  document.addEventListener('click', function(e) {
  const clickedOutsidePanel = !panel.contains(e.target);
  const clickedOutsideSidePanel = !sidePanel.contains(e.target);
  const clickedOutsideBoth = clickedOutsidePanel && clickedOutsideSidePanel;
  const notDeptBtn = e.target !== deptBtn;

  if (clickedOutsideBoth && notDeptBtn) {
    if (panel.classList.contains('active')) {
      panel.classList.remove('active');
      document.body.classList.remove('menu-open');
    }
    if (sidePanel.classList.contains('active')) {
      sidePanel.classList.remove('active');
      sidePanel.innerHTML = '';
    }
  }
});


  panel.addEventListener('click', function(e){ e.stopPropagation(); });
  sidePanel.addEventListener('click', function(e){ e.stopPropagation(); });

});
